import { getData, postData, putData } from "./rest-api-helper";


export async function rmvProjFrSourceUserServ(data) {
    const details = {
        urlPath: `/source/project/rmvProjFromSource`,
        body: {
            ...data
        }
    }
    const res = await putData(details);
    return res;
}

export async function assignProjSourceUserServ({ userId, comId, projIdStrg }) {
    //userId,comId, projIdStrg
    const details = {
        urlPath: `/source/project/assignProjSource`,
        body: {
            userId, comId, projIdStrg
        }
    }
    const res = await putData(details);
    return res;
}

export async function getSrcComEmpServ({ comId, limit, pageNumber, searchWord, userType, sourceUserId }) {
    const details = {
        urlPath: "/source/company/employees",
        queryParams: {
            sourceUserId,
            ...(comId && { comId }),
            ...(searchWord && { searchWord }),
            ...(limit && { limit }),
            ...(pageNumber && { offset: (pageNumber * limit) - limit }),
            ...(userType && { userType }),
        }
    }
    const res = await getData(details);
    return res.data;
}

export async function getSrcNewProdReqs({ limit, pageNumber, searchWord, sourceUserId }) {
    const details = {
        urlPath: "/source/newProdReqs",
        queryParams: {
            sourceUserId,
            ...(searchWord && { searchWord }),
            ...(limit && { limit }),
            ...(pageNumber && { offset: (pageNumber * limit) - limit }),
        }
    }
    const res = await getData(details);
    return res.data;
}

export async function sendAckServ(data) {
    const details = {
        urlPath: `/source/po/sendAck`,
        body: {
            ...data
        }
    }
    const res = await postData(details);
    return res;
}

export async function sendOrderCfmServ(data) {
    const details = {
        urlPath: `/source/po/sendOrderCfm`,
        body: {
            ...data
        }
    }
    const res = await postData(details);
    return res;
}

export async function updateActPoNumServ(data) {
    const details = {
        urlPath: `/source/po/updateActPoNum`,
        body: {
            ...data
        }
    }
    const res = await putData(details);
    return res;
}